import amex from './amex.svg';
import diners from './diners.svg';
import discover from './discover.svg';
import elo from './elo.svg';
import mastercard from './mastercard.svg';
import visa from './visa.svg';

export default { mastercard, visa, 'american-express': amex, elo, 'diners-club': diners, discover };



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/OrderPaymentForm/CreditCardFields/cardImages/index.js